import { PageController } from '@client/components/_core/layout/PageController';
import { errorMessage } from '@client/components/_ui/feedback/error-message/ErrorMessage';
import { message } from '@client/components/_ui/feedback/message';
import { ReleaseEditor } from '@client/components/whats-new-admin/ReleaseEditor';
import { useAdminModulePermissions } from '@client/hooks/admin/useAdminModulePermissions';
import { useTrpc } from '@client/hooks/api/useTrpc';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/admin-console/platform-content/whats-new/new')({
    staticData: {
        breadcrumb: { title: 'New release' },
        ui: { title: 'New release', subtitle: 'Draft a release note; publish it when the feature is live' },
    },
    component: NewReleaseRoute,
});

function NewReleaseRoute() {
    const { isReadOnly } = useAdminModulePermissions('content');
    if (isReadOnly) {
        return <Navigate to="/admin-console/platform-content/whats-new" />;
    }
    return (
        <PageController route={Route}>
            <NewRelease />
        </PageController>
    );
}

function NewRelease() {
    const { trpc, trpcUtils } = useTrpc();
    const navigate = useNavigate();
    const { mutate: createRelease, isPending } = trpc.admin.whatsNew.createRelease.useMutation({
        onError: (error) => errorMessage.show(error),
        onSuccess: ({ id }) => {
            message.success('Draft created');
            void trpcUtils.admin.whatsNew.listReleases.invalidate();
            navigate({
                to: '/admin-console/platform-content/whats-new/$id',
                params: { id: String(id) },
                replace: true,
            });
        },
    });

    return (
        <ReleaseEditor mode="create" isReadOnly={false} isSaving={isPending} onSave={(input) => createRelease(input)} />
    );
}
